import spainContactsConfig from "./contacts.config";

// Spain has a single office currently; extendable for future branches
const officesConfig = [spainContactsConfig];

export default officesConfig;
